<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      keep-source
      row-key
      ref="table"
      size="small"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <h5>{{ $l('title_sample_material') || '物料构成' }}</h5>
        </slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageCode
              ? $osscdn(row.defaultImageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width: 100px; height: 66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:materialNoInfo="{ row }">
        <span>{{ row.materialNo }} </span>
        <br />
        <span
          >{{ row.mainMaterialCategoryName }} /
          {{ row.detailMaterialCategoryName }}</span
        >
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialName }} </span>
        <br />
        <span>{{ row.materialNameEn }}</span>
        <br />
      </template>
      <template v-slot:displayNameInfo="{ row }">
        <span>{{ row.displayName }} </span>
        <br />
        <span>{{ row.displayNameEn }}</span>
      </template>
      <template v-slot:usageQtyInfo="{ row }">
        <span>{{ row.usageQty }} {{ row.qtyUnit }}</span>
      </template>
      <template v-slot:priceInfo="{ row }">
        <span>{{ row.price }} / {{ row.v_qtyUnit ? row.v_qtyUnit : '--' }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    sampleCode: String,
    productLine: String,
    proofingCode: String,
  },
  data() {
    return {
      loading: false,
      tableHeight: 500,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.loadData(),
        },
        zoom: true,
        custom: true,
      },
      tableData: [],
      tableColumns: tableColumns(this),
      sampleMaterialDialogOptions: {
        disabled: false,
        visible: false,
        title: '',
        formData: {},
      },
    }
  },
  watch: {
    sampleCode: {
      handler() {
        this.loadData()
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      this.getData(this.sampleCode).then((res) => {
        this.tableData = []
        this.tableData = res
      })
    },
    async getData(sampleCode) {
      if (!sampleCode) return Promise.resolve([])
      return await this.$api
        .sampleInfoMaterialListApi({ sampleCode })
        .then((res) => Promise.resolve(res.body.data))
    },
  },
}
</script>
